module.exports = __webpack_public_path__ + "static/img/4.3584a46.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/eng/4.png
// module id = vLAd
// module chunks = 0